import { render, staticRenderFns } from "./BSaleEndTimer.vue?vue&type=template&id=111e68e3"
import script from "./BSaleEndTimer.vue?vue&type=script&setup=true&lang=ts"
export * from "./BSaleEndTimer.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports